
const pubsub = {};

const topics = {};
let subUid = -1;

pubsub.subscribe = (topic, func) => {
  if (!topics[topic]) {
    topics[topic] = [];
  }

  const token = (subUid += 1).toString();

  topics[topic].push({
    token,
    func,
  });

  return token;
};

pubsub.publish = (topic, args) => {
  if (!topics[topic]) {
    return false;
  }
  setTimeout(() => {
    const subscribers = topics[topic];
    let len = subscribers ? subscribers.length : 0;

    while (len) {
      len -= 1;
      subscribers[len].func(topic, args);
    }
  }, 0);

  return true;
};

pubsub.unsubscribe = (token) => {
  let unsubscribedToken;

  Object.keys(topics).forEach((topic) => {
    if (topics[topic]) {
      for (let i = 0, j = topics[topic].length; i < j; i += 1) {
        if (topics[topic][i].token === token) {
          topics[topic].splice(i, 1);
          unsubscribedToken = token;
        }
      }
    }
  });

  return (typeof unsubscribedToken !== 'undefined') ? unsubscribedToken : false;
};

module.exports = pubsub;



// WEBPACK FOOTER //
// ./src/utils/pubSub.js